export default "__VITE_ASSET__Baz36z6Z__"